import type { LocationQuery } from 'vue-router'
import type { TasksKanbanLogsFilterParams } from '../interfaces'

import { parseStringParam } from '@shared/lib/url'

export const parseLogFilterParams = (query: LocationQuery): TasksKanbanLogsFilterParams => {
  return {
    query: parseStringParam(query, 'query'),
    date_from: parseStringParam(query, 'date_from'),
    date_to: parseStringParam(query, 'date_to'),
  }
}

export const buildLogQueryObject = (params: TasksKanbanLogsFilterParams): Record<string, string> => {
  const query: Record<string, string> = {}

  if (params.query) query.query = params.query
  if (params.date_from) query.date_from = params.date_from
  if (params.date_to) query.date_to = params.date_to

  return query
}